import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import type { ImportProgress } from '../../../common/interfaces/import-progress';
import type { DriversImportData } from '../constants/drivers-import-schema';
import { DriversService } from '../services/drivers.service';

export const importDriversResolver: ResolveFn<
  (data: DriversImportData[]) => Observable<ImportProgress>
> = () => {
  const driversService = inject(DriversService);
  return (data) => driversService.importDrivers(data);
};
